import {useSearchParams} from "react-router-dom";

export const useUrlParams = () => {
    const [searchParams, setSearchParams] = useSearchParams();

    const setParam = (key, value) => {
        const updated = new URLSearchParams(searchParams);
        if (value === undefined || value === null) {
            updated.delete(key);
        } else {
            updated.set(key, value);
        }
        setSearchParams(updated);
    };

    const removeParam = (key) => {
        const updated = new URLSearchParams(searchParams);
        updated.delete(key);
        setSearchParams(updated);
    };

    return {
        setParam,
        removeParam,
        searchParams, // optional: if you want to access current params
    };
};
